const e = {
  "cdr-skeleton": "cdr-skeleton_16-3-1"
};
export {
  e as default
};
